import axios from "axios";
import { API_URL, ApiResponse } from "@/api/api.ts";
import { loginState } from "@/states.ts";

export interface User {
	id: number;
	email: string;
	api_token?: string;
	features?: string[];
}

export interface UserResponse extends ApiResponse {
	user?: User;
}

export const fetchUser = async () => {
	return axios
		.get<UserResponse>(`${API_URL}/user`, {
			headers: {
				Authorization: loginState.token,
			},
		})
		.then((res) => res.data);
};

export interface UpdateUserResponse extends ApiResponse {
	user?: User;
}

export const updateUser = async (email: string, password: string) => {
	return axios
		.post<UpdateUserResponse>(
			`${API_URL}/user/`,
			{ email, password },
			{
				headers: {
					"Content-Type": "application/json",

					Authorization: loginState.token,
				},
			},
		)
		.then((res) => res.data);
};

export interface UpdatePasswordResponse extends ApiResponse {}

export const updatePassword = async (password: string, password2: string) => {
	return axios
		.post<UpdatePasswordResponse>(
			`${API_URL}/user/password`,
			{
				password,
				password2,
			},
			{
				headers: {
					"Content-Type": "application/json",
					Authorization: loginState.token,
				},
			},
		)
		.then((res) => res.data);
};

export interface RegenerateTokenResponse extends ApiResponse {
	api_token?: string;
}

export const regenerateApiToken = async () => {
	return axios
		.post<RegenerateTokenResponse>(
			`${API_URL}/user/regenerate_token`,
			{},
			{
				headers: {
					"Content-Type": "application/json",
					Authorization: loginState.token,
				},
			},
		)
		.then((res) => res.data);
};
